// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomFilter_filterItemContainer__D16vx {
  width: 20rem;
}

.CustomFilter_checkFilter__OWgzQ {
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  width: auto;
  display: flex;
  flex-wrap: nowrap;
  border: 1px solid var(--branded-light-purple) !important;
  border-radius: 6px;
  height: 40px;
}

.CustomFilter_checkFilterLabel__E-ZGy {
  margin-left: 10px;
  margin-top: -3px;
}

.CustomFilter_filterBar__xGKd8 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
}

.CustomFilter_barFilters__-WILc {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  row-gap: 10px;
  column-gap: 15px;
  align-items: flex-end;
}

.CustomFilter_filters_button__iuAlU {
  background-color: #ffffff !important;
  border: 1px solid var(--branded-purple-border) !important;
  color: var(--branded-font-color) !important;
  border-radius: 4px;
  height: 40px;
  width: 150px;
}

.CustomFilter_panelFilterContainer__WBobl {
  display: grid;
  grid-template-columns: 20rem 20rem;
  grid-template-rows: auto;
  row-gap: 20px;
  column-gap: 20px;
}

.CustomFilter_filterDialog__\\+jGDL {
  width: auto;
}

.CustomFilter_filterDialogFooter__PmGam {
  display: flex;
  flex-wrap: wrap;
  margin-top: 2rem;
  column-gap: 20px;
  row-gap: 20px;
  justify-content: space-between;
}

.CustomFilter_filterDialogButtons__4OGPN {
  display: flex;
  justify-content: flex-end;
  column-gap: 10px;
  row-gap: 20px;
}

.CustomFilter_headerLabel__yq\\+iT {
  font-weight: 700;
  font-size: 12px;
  line-height: 16.34px;
  color: #495057;
  margin-bottom: 5px;
}

.CustomFilter_filterItemBorder__hJ8G0 {
  border-style: solid;
  border-width: 1px;
  border-color: var(--branded-purple-border);
}

.CustomFilter_calendarFilter__82w9D {
  border-radius: 7px;
}

.CustomFilter_textFilter__Jnl-4 {
  border-color: var(--branded-purple-border) !important;
}

.CustomFilter_checkFilter__OWgzQ {
  border-color: var(--branded-purple-border) !important;
}

.CustomFilter_barFilterItem__8skQj {
  width: fit-content;
  max-width: 100%;
  min-width: 200px;
}

/* tablet */
@media (min-width: 768px) and (max-width: 1024px) {
  .CustomFilter_filterBar__xGKd8 {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    row-gap: 10px;
    column-gap: 10px;
  }

  .CustomFilter_barFilters__-WILc {
    width: 100%;
  }
}

/* mobile */
@media (max-width: 768px) {
  .CustomFilter_filterDialog__\\+jGDL {
    width: 90%;
  }

  .CustomFilter_panelFilterContainer__WBobl {
    grid-template-columns: 1fr;
    width: 100%;
  }

  .CustomFilter_filterBar__xGKd8 {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    row-gap: 10px;
    column-gap: 10px;
  }

  .CustomFilter_barFilters__-WILc {
    width: 100%;
  }

  .CustomFilter_filterItemContainer__D16vx {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/CustomFilter.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,wDAAwD;EACxD,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;EACzD,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,wBAAwB;EACxB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,WAAW;AACX;EACE;IACE,UAAU;EACZ;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".filterItemContainer {\n  width: 20rem;\n}\n\n.checkFilter {\n  padding-top: 10px;\n  padding-left: 10px;\n  padding-right: 10px;\n  width: auto;\n  display: flex;\n  flex-wrap: nowrap;\n  border: 1px solid var(--branded-light-purple) !important;\n  border-radius: 6px;\n  height: 40px;\n}\n\n.checkFilterLabel {\n  margin-left: 10px;\n  margin-top: -3px;\n}\n\n.filterBar {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n\n.barFilters {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  row-gap: 10px;\n  column-gap: 15px;\n  align-items: flex-end;\n}\n\n.filters_button {\n  background-color: #ffffff !important;\n  border: 1px solid var(--branded-purple-border) !important;\n  color: var(--branded-font-color) !important;\n  border-radius: 4px;\n  height: 40px;\n  width: 150px;\n}\n\n.panelFilterContainer {\n  display: grid;\n  grid-template-columns: 20rem 20rem;\n  grid-template-rows: auto;\n  row-gap: 20px;\n  column-gap: 20px;\n}\n\n.filterDialog {\n  width: auto;\n}\n\n.filterDialogFooter {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 2rem;\n  column-gap: 20px;\n  row-gap: 20px;\n  justify-content: space-between;\n}\n\n.filterDialogButtons {\n  display: flex;\n  justify-content: flex-end;\n  column-gap: 10px;\n  row-gap: 20px;\n}\n\n.headerLabel {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16.34px;\n  color: #495057;\n  margin-bottom: 5px;\n}\n\n.filterItemBorder {\n  border-style: solid;\n  border-width: 1px;\n  border-color: var(--branded-purple-border);\n}\n\n.calendarFilter {\n  border-radius: 7px;\n}\n\n.textFilter {\n  border-color: var(--branded-purple-border) !important;\n}\n\n.checkFilter {\n  border-color: var(--branded-purple-border) !important;\n}\n\n.barFilterItem {\n  width: fit-content;\n  max-width: 100%;\n  min-width: 200px;\n}\n\n/* tablet */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .filterBar {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    row-gap: 10px;\n    column-gap: 10px;\n  }\n\n  .barFilters {\n    width: 100%;\n  }\n}\n\n/* mobile */\n@media (max-width: 768px) {\n  .filterDialog {\n    width: 90%;\n  }\n\n  .panelFilterContainer {\n    grid-template-columns: 1fr;\n    width: 100%;\n  }\n\n  .filterBar {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    row-gap: 10px;\n    column-gap: 10px;\n  }\n\n  .barFilters {\n    width: 100%;\n  }\n\n  .filterItemContainer {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterItemContainer": `CustomFilter_filterItemContainer__D16vx`,
	"checkFilter": `CustomFilter_checkFilter__OWgzQ`,
	"checkFilterLabel": `CustomFilter_checkFilterLabel__E-ZGy`,
	"filterBar": `CustomFilter_filterBar__xGKd8`,
	"barFilters": `CustomFilter_barFilters__-WILc`,
	"filters_button": `CustomFilter_filters_button__iuAlU`,
	"panelFilterContainer": `CustomFilter_panelFilterContainer__WBobl`,
	"filterDialog": `CustomFilter_filterDialog__+jGDL`,
	"filterDialogFooter": `CustomFilter_filterDialogFooter__PmGam`,
	"filterDialogButtons": `CustomFilter_filterDialogButtons__4OGPN`,
	"headerLabel": `CustomFilter_headerLabel__yq+iT`,
	"filterItemBorder": `CustomFilter_filterItemBorder__hJ8G0`,
	"calendarFilter": `CustomFilter_calendarFilter__82w9D`,
	"textFilter": `CustomFilter_textFilter__Jnl-4`,
	"barFilterItem": `CustomFilter_barFilterItem__8skQj`
};
export default ___CSS_LOADER_EXPORT___;
